<template>
  <!--客观题弹框 -->
  <el-dialog
    class="objective-dialog dialog"
    title="客观题"
    width="1080px"
    top="10px"
    :visible="value"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('input', false)"
  >
    <el-form
      :inline="true"
      :model="formData"
      :rules="rulesFrom"
      ref="formData"
      class="demo-Form"
    >
      <el-form-item label="大题题号：" prop="th">
        <el-select
          v-model="formData.th"
          placeholder="请选择"
          style="width: 100px"
          size="small"
        >
          <el-option
            v-for="item in bigNumList"
            :key="'th' + item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="limit-title" label="题目名称：" prop="name">
        <el-input
          class="topic_name"
          show-word-limit
          type="text"
          placeholder="请输入内容"
          v-model="formData.name"
          maxlength="27"
          size="small"
        ></el-input>
      </el-form-item>
      <div class="form-step"></div>
      <el-form-item prop="tType" :label="'题\xa0\xa0\xa0\xa0\xa0\xa0型：'">
        <el-select
          v-model="formData.tType"
          placeholder="请选择"
          style="width: 100px"
          size="small"
          @change="bigtTypeChange(formData)"
        >
          <el-option :value="1" label="单选"></el-option>
          <el-option :value="2" label="多选"></el-option>
          <el-option :value="3" label="判断"></el-option>
        </el-select>
      </el-form-item>
      <div class="el-form-item">
        <label class="el-form-item__label add_x">{{
          "题" + "\xa0\xa0\xa0\xa0\xa0\xa0" + "号："
        }}</label>
        <el-form-item prop="start" ref="start_inp">
          <IntegerInput v-model="formData.start" />
          <!-- <el-input-number v-model="formData.start" :controls="false" size="small" :min="1"></el-input-number> -->
        </el-form-item>
        <span class="dia-name" style="padding: 0 10px">至</span>
        <el-form-item prop="end" ref="end_inp">
          <IntegerInput v-model="formData.end" />
        </el-form-item>
      </div>
      <el-form-item
        :label="'每\xa0\xa0\xa0\xa0\xa0\xa0题：'"
        prop="score"
        class="wh75"
      >
        <el-input-number
          v-model="formData.score"
          :controls="false"
          size="small"
          type="number"
          :precision="2"
        ></el-input-number>
        <span>分</span>
      </el-form-item>
      <el-form-item :label="'每\xa0\xa0\xa0\xa0\xa0\xa0题：'" prop="optionNum">
        <!-- <el-input-number
          v-model="formData.optionNum"
          :controls="false"
          size="small"
          :step="1"
          :min="2"
          :max="16"
          :disabled="formData.tType === 3"
        /> -->
        <IntegerInput
          v-model="formData.optionNum"
          :disabled="formData.tType === 3"
        />
        <span>选项</span>
      </el-form-item>
      <el-form-item
        label="部分正解："
        prop="partScore"
        ref="part_score_inp"
        v-if="formData.tType === 2"
      >
        <el-input-number
          v-model="formData.partScore"
          :controls="false"
          :precision="2"
          size="small"
          :min="0"
        />
        <span>分</span>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="addButtonLoading"
          type="primary"
          icon="el-icon-plus"
          style="margin-left: 15px"
          @click="addItems"
          circle
          size="mini"
        ></el-button>
      </el-form-item>
    </el-form>
    <div class="dialog-cont">
      <el-button class="clear-table" type="text" @click="clearList(true)"
        >清空列表</el-button
      >
      <div class="dialog-list">
        <el-table :data="formData.items" height="300px">
          <el-table-column label="题号" align="center">
            <template slot-scope="scope">{{ scope.row.no }}</template>
          </el-table-column>
          <el-table-column label="题型" align="center">
            <template slot-scope="scope">{{
              scope.row.tType === 1
                ? "单选"
                : scope.row.tType === 2
                ? "多选"
                : "判断"
            }}</template>
          </el-table-column>
          <el-table-column label="分值" align="center">
            <template slot-scope="scope">
              <el-input-number
                :controls="false"
                v-model="scope.row.score"
                type="number"
                :precision="2"   
                size="small"
              />
            </template>
          </el-table-column>
          <el-table-column label="选项数" align="center">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.optionNum"
                :controls="false"
                size="small"
                :step="1"
                :step-strictly="true"
                :min="2"
                :max="16"
                :disabled="scope.row.tType == 3"
              />
            </template>
          </el-table-column>
          <el-table-column label="部分得分" align="center">
            <!-- <template slot-scope="scope">
              <el-input
                v-model="scope.row.partScore"
                :disabled="scope.row.tType !== 2"
                size="small"
              ></el-input>
            </template> -->
            <template slot-scope="scope">
              <el-input-number
                :controls="false"
                v-if="scope.row.tType == 2"
                v-model="scope.row.partScore"
                type="number"
                :precision="2"   
                size="small"
              />
              <el-input-number
                :controls="false"
                v-if="scope.row.tType !== 2"
                v-model="scope.row.partScore"
                type="number"
                :precision="2"   
                size="small"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="deleteItem(scope)"
                icon="el-icon-delete"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="dialogSubmit('formData')"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
//客观题
import { mapState, mapGetters, mapMutations } from "vuex";
import cardOperate from "@/assets/js/utils/cardOperate";
import { THS } from "../constant";
import { ObjectiveModel } from "@/subjects/objective/Objective.model";
import { overNum, setObjectiveHeight } from "@/utils/common";
import { initTopicBoxMixins } from '../../mixins/initTopicBoxFormData.mixins'
export default {
  name: "Objective",
  props: ["value", "type", "subject"],
  mixins: [initTopicBoxMixins],
  computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    ...mapState("cardMake", {
      objectiveFrom: (state) => state.objectiveFrom, //
      topicStoreroom: (state) => state.topicStoreroom,
      topicTh: (state) => state.answerSheettopicTh,
      isBoxEdit: (state) => state.isBoxEdit,
      allIndex: (state) => state.allIndex,
    }),
    ...mapState("card", {
      bigNumList: (state) => state.THS,
    }),
  },
  data(ctx) {
    var thValidate = (rule, value, callback) => {
      value = Number(value);
      let validV = new RegExp("^([1-9]\\d{0,}\\.){0,2}[1-9]\\d{0,}$");
      if (!value && value != 0) {
        console.log(ctx.formData.end);
        callback(new Error("必填"));
      } 
      // else if (!validV.test(value) && value != 0) {
      //   callback(new Error("请正确填写"));
      // } 
      else if (rule.field === "start" && value > Number(ctx.formData.end)) {
        callback(new Error("开始题号过大"));
      } else if (rule.field === "end" && value < Number(ctx.formData.start)) {
        callback(new Error("开始题号过大"));
      } else if (
        rule.field === "partScore" &&
        value > Number(ctx.formData.score)
      ) {
        callback(new Error("部分得分过大"));
      } else {
        if (rule.field === "start") {
          this.$refs["end_inp"].clearValidate();
        } else if (rule.field === "partScore") {
          this.$refs["part_score_inp"].clearValidate();
        } else {
          this.$refs["start_inp"].clearValidate();
        }
        callback();
      }
    };
 let thValidateEmpty = (rule, value, callback) => {
      if (!value) {
        callback(new Error("必填"));
      } else {
        callback();
      }
    };
    return {
      addButtonLoading: false,
      isClickAdd: 0, // 0、只修改未点击 1、修改点击了 2、点击后又修改
      formData: new ObjectiveModel({ name: ctx.type }),
      rulesFrom: {
        th: [{ validator: thValidateEmpty, message: "题号必选", trigger: "blur" }],
        name: [{ validator: thValidateEmpty, message: "必填", trigger: "blur" }],
        tType: [{ validator: thValidateEmpty, message: "必填", trigger: "blur" }],
        start: [{ validator: thValidate, trigger: "blur" }],
        end: [{ validator: thValidate, trigger: "blur" }],
        score: [{ validator: thValidateEmpty, message: "必填", trigger: "blur" }],
        partScore: [{ validator: thValidate, trigger: "blur" }],
        optionNum: [{ validator: thValidateEmpty, message: "必填", trigger: "blur" }],
        // partScore: [{ required: true, message: "必填", trigger: "blur" }],
      },
      topicThMove: {
        isAdd: false,
        bigTh: [],
        smallTh: [],
      },
      changeObj: {},
    };
  },
  watch: {
    value(val) {
      if (val) {
        if (this.subject) {
          this.subject.oldSubject =
            this.subject && JSON.parse(JSON.stringify(this.subject));
          const obj = JSON.parse(JSON.stringify(this.subject));
          this.changeObj = {
            ...this.changeObj,
            tType: obj.tType,
            score: obj.score,
            optionNum: obj.optionNum,
          };
        }
        this.subject
          ? (this.formData = new ObjectiveModel(this.subject.oldSubject))
          : (this.formData = new ObjectiveModel({ name: this.type }));
        this.clearHistoryTopicFormData();
        if(this.formData.tType === 3) {
          // 为了编辑的时候 自动填充判断题的选项数，去除验证
          this.formData.optionNum = 2;
        }
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    createItems(formName) {
      let self = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 如果是编辑就追加题型
          if (this.subject) {
            const flag = overNum(this, 200);
            if (flag) return;
          } else {
            if (
              !this.formData.items.length &&
              this.formData.end - this.formData.start > 200
            ) {
              this.$message({
                message: "超出200题，无法添加！",
                type: "warning",
                customClass: "mzindex",
              });
              this.addButtonLoading = false;
              return;
            }
            const flag = overNum(this, 200);
            if (flag) return;
          }
          this.addButtonLoading = true;
          const timer = setTimeout(() => {
            // this.subject
            //   ? this.formData.addItems(this.formData)
            //   : this.formData.createItems(this.formData);
            this.formData.addItems(this.formData);
            this.clearHistoryTopicFormData('creatItems');
            this.addButtonLoading = false;
            clearTimeout(timer);
          });
          // this.formData.addItems(this.formData)
          // this.subject
          //   ? this.formData.addItems(this.formData)
          //   : this.formData.createItems(this.formData);
        } else {
        }
      });
    },
    addItems() {
      if (this.subject) {
        if (this.isClickAdd === 0) {
          if (
            this.subject.start > this.formData.start ||
            this.subject.end < this.formData.end ||
            this.formData.items.length === 0
          ) {
            const obj = JSON.parse(JSON.stringify(this.formData));
            this.changeObj = {
              ...this.changeObj,
              start: obj.start,
              end: obj.end,
              tType: obj.tType,
              score: obj.score,
              optionNum: obj.optionNum,
            };
            this.isClickAdd = 1;
          } else {
            const obj = JSON.parse(JSON.stringify(this.subject));
            this.changeObj = {
              ...this.changeObj,
              start: obj.start,
              end: obj.end,
              tType: obj.tType,
              score: obj.score,
              optionNum: obj.optionNum,
            };
          }
        } else {
          if (
            this.changeObj.start > this.formData.start ||
            this.changeObj.end < this.formData.end ||
            this.formData.items.length === 0
          ) {
            const obj = JSON.parse(JSON.stringify(this.formData));
            this.changeObj = {
              ...this.changeObj,
              start: obj.start,
              end: obj.end,
              tType: obj.tType,
              score: obj.score,
              optionNum: obj.optionNum,
            };
          }
        }
      } else {
        // 新增
        if (!this.changeObj.start) {
          const obj = JSON.parse(JSON.stringify(this.formData));
          this.changeObj = {
            ...this.changeObj,
            start: obj.start,
            end: obj.end,
            tType: obj.tType,
            score: obj.score,
            optionNum: obj.optionNum,
          };
        } else {
          if (
            this.changeObj.start > this.formData.start ||
            this.changeObj.end < this.formData.end ||
            this.formData.items.length === 0
          ) {
            const obj = JSON.parse(JSON.stringify(this.formData));
            this.changeObj = {
              ...this.changeObj,
              start: obj.start,
              end: obj.end,
              tType: obj.tType,
              score: obj.score,
              optionNum: obj.optionNum,
            };
          }
        }
      }
      this.createItems("formData");
    },
    //添加小题
    bigtTypeChange(row) {
      if (row.tType == 3) {
        row.optionNum = 2;
      }
      // this.clearList();
    },
    tTypeChange(row) {
      if (row.tType == 3) {
        row.optionNum = 2;
      }
    }, //
    clearList() {
      this.formData.items = [];
    }, //清空列表
    dialogClose() {
      if (this.subject) {
        this.subject.oldSubject =
          this.subject && JSON.parse(JSON.stringify(this.subject));
      }
      this.$emit("input", false);
    },
    async dialogSubmit(formName) {
      if (this.submitDisabled) {
        return false;
      }
      this.submitDisabled = true;
      let timer = setTimeout(() => {
        this.submitDisabled = false;
        clearTimeout(timer);
      }, 500);
      if (!this.formData.items.length) {
        this.$message({
          type: "warning",
          message: "列表不能为空，请点击‘+’号按钮，添加题目！",
          customClass: "mzindex",
        });
        return;
      }
      // this.$refs[formName].validate((valid) => {
        // if (valid) {
          if (this.changeObj.start) {
            const obj = JSON.parse(JSON.stringify(this.changeObj));
            this.formData = {
              ...this.formData,
              tType: obj.tType,
              score: obj.score,
              optionNum: obj.optionNum,
            };
          }
          this.formData = new ObjectiveModel(this.formData);
          this.$emit("submit-objective", this.formData);
          if (this.subject) {
            this.subject.oldSubject =
              this.subject && JSON.parse(JSON.stringify(this.subject));
          }
        // } else {
        // }
      // });
    }, //确定大型设置完成
    deleteItem(scope) {
      const idx = scope.$index;
      this.formData.deleteItem(idx);
    },
   
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >
.dialog {
  .wh75 {
    .el-input-number {
      width: 65px;
    }
  }
}
.form-step {
  width: 100%;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}
.add_x:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.dialog-list {
  .el-input-number {
    width: 80%;
  }
}
.topic_name {
  span {
    padding: 0;
  }
}
.mzindex {
  z-index: 3000000 !important;
}
</style>
